// 
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../edeeshop/jquery.edeeshop-photogallery';

/**
 * requires jquery.edeeshop-photogallery.js
 * Edeeshop Photogallery support
 *		- renders details from thumblist
 *		- renders control arrows
 *		- renders zoom (magnify) button if has support
 *		- renders 3D model button, if has support
 */
export default class EshopPhotogallery extends WebComponent {
	didMount() {
		const {
			magnifyEnabled,
			model3dEnabled,
			popupGalleryEnabled,
			onlyThumbnailEnabled,
			activeDetail,
      allowKeyboardSwitch,
      allowMousewheelSwitch,
      arrowsEnabled,
      bulletsEnabled,
      webpEnabled,
      retinaEnabled,
		} = this.props;

		$(this.element).edeeshopPhotogallery({
			magnifyEnabled: magnifyEnabled !== false,
			model3DEnabled: model3dEnabled !== false,
			popupGalleryEnabled: popupGalleryEnabled !== false,
			onlyThumbnailEnabled: onlyThumbnailEnabled !== false,
			activeDetail: parseInt(activeDetail) || 0,
      allowKeyboardSwitch: allowKeyboardSwitch !== false,
      allowMousewheelSwitch: allowMousewheelSwitch !== false,
      arrowsEnabled: arrowsEnabled !== false,
      bulletsEnabled: bulletsEnabled === true,
      webpEnabled: webpEnabled === true,
      retinaEnabled: retinaEnabled === true,
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/EshopPhotogallery.js